import clsx from 'clsx'
import type { ComponentPropsWithoutRef, ReactNode } from 'react'

import { AdminHelp } from './AdminHelp'

export type AdminToggleProps = Omit<
  ComponentPropsWithoutRef<'input'>,
  'type'
> & {
  label?: ReactNode
  help?: ReactNode
}
export const AdminToggle = ({
  label,
  className,
  help,
  ...props
}: AdminToggleProps) => {
  return (
    <div>
      <label className="label cursor-pointer justify-normal space-x-2">
        <input
          className={clsx(
            'toggle toggle-primary duration-300 ease-in-out',
            className,
          )}
          type="checkbox"
          {...props}
        />
        <span className="text-sm text-base-content">{label}</span>
        {help && <AdminHelp>{help}</AdminHelp>}
      </label>
    </div>
  )
}
